import script from "./PrivacyPolicy.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrivacyPolicy.vue?vue&type=script&setup=true&lang=ts"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=dcc4121c&lang=css"

const __exports__ = script;

export default __exports__